<template>
    <zen-message-modal :isOpen="isOpen" title="Cancel Scheduled Target Change?">
        Are you sure you want to cancel this scheduled target change? This
        action is permanent.
        <template v-slot:buttons>
            <zen-button variant="primary-danger" @click="$emit('confirm')">
                Remove
            </zen-button>
            <zen-button variant="secondary" @click="$emit('close')">
                Cancel
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'CancelScheduledTargetModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['close', 'confirm'],
}
</script>
